// pages/EmergencyMaterials.js
import { useEffect, useState } from 'react';
import { fetchWithAuth } from '../auth';
import Breadcrumbs from '../components/Breadcrumbs';

const fileNameFromUrl = (url) => {
  try {
    const u = new URL(url, window.location.origin);
    return decodeURIComponent(u.pathname.split('/').pop() || 'קובץ');
  } catch {
    return 'קובץ';
  }
};

const itemTitle = (f) => {
  if (f?.title && f.title.trim()) return f.title.trim();
  if (f?.file) return fileNameFromUrl(f.file);
  if (f?.url) {
    try {
      const u = new URL(f.url);
      const host = u.hostname.replace(/^www\./, '');
      const path = u.pathname.replace(/\/$/, '');
      return `${host}${path !== '/' ? path : ''}` || f.url;
    } catch {
      return f.url;
    }
  }
  return 'קישור';
};

export default function EmergencyMaterials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await fetchWithAuth('/api/emergency-materials/');
        if (!res.ok) throw new Error('failed');
        const data = await res.json();
        if (!ignore) setItems(data);
      } catch {
        if (!ignore) setError('שגיאה בטעינת החומרים');
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, []);

  return (
    <div className="container">
      <Breadcrumbs
        items={[
          { to: '/tractates', label: 'מסכתות' },
          { label: 'מיקוד מלחמה תשפו ולמידה בשעת חירום' },
        ]}
      />

      <div className="toolbar toolbar--center">
        <h2 style={{ marginInlineStart: 0 }}>מיקוד מלחמה תשפו ולמידה בשעת חירום</h2>
      </div>

      {loading && <p className="muted">טוען…</p>}
      {error && <p style={{ color: 'crimson' }}>{error}</p>}

      {!loading && !error && items.length === 0 && (
        <p className="muted" style={{ textAlign: 'center' }}>אין חומרים להצגה עדיין.</p>
      )}

      {!loading && !error && items.length > 0 && (
        <div className="cf-table">
          {items.map((f) => {
            const title = itemTitle(f);
            const isLink = !!f.url && !f.file;
            const hasFile = !!f.file;
            const downloadName = hasFile ? fileNameFromUrl(f.file) : '';

            return (
              <div key={f.id} className="cf-row">
                <div className="cf-main">
                  <div className="cf-title">{title}</div>
                  {f.author ? (
                    <div className="cf-author muted">מאת {f.author}</div>
                  ) : null}
                  {isLink ? (
                    <div className="muted" style={{ fontSize: '.85rem' }}>קישור חיצוני</div>
                  ) : null}
                </div>

                <div className="cf-actions" style={{ display: 'flex', gap: '.5rem' }}>
                  {isLink && (
                    <a
                      className="btn btn--sm"
                      href={f.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`פתיחת קישור: ${title}`}
                    >
                      פתיחה
                    </a>
                  )}
                  {hasFile && (
                    <a
                      className="btn btn--sm"
                      href={f.file}
                      download={downloadName}
                      aria-label={`הורדת ${title}`}
                    >
                      הורדה
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
